import type {ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import {Button, cn, useCopyToClipboard} from '@chekinapp/ui';
import {useRegistrationShareLink} from 'hooks/useRegistrationShareLink';

const PILL_CLASS = 'h-8 min-w-0 px-3.5 text-[12px] font-semibold';

type Props = {
  title: ReactNode;
  description?: ReactNode;
  onCopy: () => void;
  onShare: () => void;
  className?: string;
};

function VelaInviteCard({title, description, onCopy, onShare, className}: Props) {
  const {t} = useTranslation();
  const link = useRegistrationShareLink();
  const {isCopied, copy} = useCopyToClipboard({value: link, onCopiedLink: onCopy});

  return (
    <div
      className={cn(
        'flex flex-col gap-1 rounded-[14px] bg-[var(--chekin-blue-surface-100)] p-3.5',
        className,
      )}
    >
      <strong className="text-[13px] font-bold leading-[18px] text-[var(--chekin-color-brand-navy)]">
        {title}
      </strong>
      {description && (
        <span className="text-[12px] leading-[17px] text-[var(--assistant-tip-description)]">
          {description}
        </span>
      )}
      <div className="mt-2 flex gap-2">
        <Button size="s" className={PILL_CLASS} onClick={copy} disabled={!link}>
          {isCopied ? t('copied') : t('copy_link')}
        </Button>
        <Button size="s" variant="inverse" className={PILL_CLASS} onClick={onShare}>
          {t('share')}
        </Button>
      </div>
    </div>
  );
}

export {VelaInviteCard};
